import React, { useEffect, useState } from "react";
import {
  CardContent,
  Typography,
  Box,
  Stack,
  Divider,
  Grow,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { motion } from "framer-motion";
import Typewriter from "typewriter-effect";

import { CardStyle, SocialIconButtons } from "../../styles/BannerStyles";
import {
  AfriqualeosTitle,
  MySecondButton,
  MyButton,
} from "../../styles/HomeStyles";
import { Link as RouterLink } from "react-router-dom";

const BannerCard = () => {
  return (
    // <Tilt
    //   options={options}
    //   style={{
    //     transformStyle: "preserve-3d",
    //   }}
    // >
    <CardStyle
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      // whileInView={{ opacity: 1, x: 0 }}
      component={motion.div}
      // whileHover={{ rotate: -5 }}
      transition={{
        type: "spring",
        stiffness: 40,
        delay: 0.25,
      }}
      // viewport={{ once: false }}
      sx={{ pl: { xs: 0, sm: 4 } }}
    >
      <CardContent>
        <Box m={2}>
          <Typography
            variant="h2"
            sx={{
              color: "primary.main",
            }}
          >
            Conseil en{" "}
          </Typography>
          <Typography variant="h2" sx={{ color: "secondary.main" }}>
            <Typewriter
              options={{
                strings: ["Management", "Organisation"],
                autoStart: true,
                loop: true,
                delay: 40,
                cursor: "_",
              }}
            />
          </Typography>

          <Stack direction="row" mt={3} spacing={3}>
            <MyButton
              component={RouterLink}
              to="/formulaire"
              variant="contained"
            >
              Nos Services
            </MyButton>
            <MySecondButton
              variant="outlined"
              component="a"
              href="mailto:contact@afriqualeos.com"
            >
              Contactez-nous
            </MySecondButton>
          </Stack>
          <Stack direction="row" mt={3} spacing={3}>
            <SocialIconButtons
              component="a"
              href="mailto:contact@afriqualeos.com"
            >
              <EmailIcon />
            </SocialIconButtons>
            <SocialIconButtons
              component={"a"}
              href="https://www.linkedin.com/company/afriqualeosma/"
            >
              <LinkedInIcon />
            </SocialIconButtons>
            {/* <SocialIconButtons>
              <LocalPhoneIcon />
            </SocialIconButtons> */}
          </Stack>
        </Box>
      </CardContent>
    </CardStyle>
    // </Tilt>
  );
};

export default BannerCard;
